
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

// Template Dashboard 2 MUI helper functions
import pxToRem from "assets/theme/functions/pxToRem";
import linearGradient from "assets/theme/functions/linearGradient";

const { borderWidth, borderColor } = borders;
const { transparent, gradients, info } = colors;

const checkbox = {
  styleOverrides: {
    root: {
      
    },
  },
};

export default checkbox;
